module.exports = __webpack_public_path__ + "img/smart_operation.d6d487fa.png";